module.exports = __webpack_public_path__ + "img/Infografis_ID_11.12dab8ae.jpg";